import React, {useState} from "react";
import './ShareMail.scss'
import ConfirmationModal from "../_common/ConfirmationModal";
import ErrorModal from "../_common/ErrorModal";
import {useDispatch, useSelector} from "react-redux";
import bg from '../../assets/images/olsztynek 2.jpg'
import smallBg from '../../assets/images/olsztynek 8 (2).png'
import map from '../../assets/images/mapScreen.png'
import gray from '../../assets/images/light gray.png'
import {ReactComponent as ShareIcon} from "../../assets/icons/ShareIcon.svg";
import {ReactComponent as CopyIcon} from "../../assets/icons/copy.svg";
import {ReactComponent as ArrowLeft} from "../../assets/icons/arrow-left.svg";
import {ReactComponent as CircleSquare} from "../../assets/icons/circle_square.svg";

const defaultForm = {
    email: '',
    descriptionAttached: false,
    projectTechSpecAttached: false,
    mapAttached: false,
    galleryAttached: false,
    sitePlanAttached: false,
    bookletAttached: false,
    videoAttached: false,
}

const selector = state => {
    const { language} = state;
    return {
        t: language.translator,
    }
};

const ShareMail = () => {
    const dispatch = useDispatch();
    const { t } = useSelector(selector);

    const [emailValue, setEmailValue] = useState('')
    const [formValues, setFormValues] = useState({...defaultForm})
    const [innerPending, setInnerPending] = useState(false)
    const [errorModal, setErrorModal] = useState(false)
    const [successModal, setSuccessModal] = useState(false)

    const body2 = "Zdjęcie nieruchomości: https://s3.eu-central-1.amazonaws.com/hillwood-bucket/RENDERING_IMAGE_proj_id_12__1611588396426_-1164684136.jpg \nMapa: https://s3.eu-central-1.amazonaws.com/hillwood-bucket/MAP_ZOOM_IN_proj_id_12__1612442391018_1050209548.jpg \nPlan zagospodarowania: https://s3.eu-central-1.amazonaws.com/hillwood-bucket/SITE_PLAN_proj_id_12__1637156018744_-1826794466.jpg"

    const Mailto = ({ email, subject = '', body = '', children }) => {
        let params = subject || body ? '?' : '';
        if (subject) params += `subject=${encodeURIComponent(subject)}`;
        if (body) params += `${subject ? '&' : ''}body=${encodeURIComponent(body)}`;

        return <a href={`mailto:${email}${params}`}>{children}</a>;
    };

    const subject = `Szczegóły projektu "Hillwood Janki II"`

    const sendEmail = () => {
        if(!innerPending && (formValues.email.length > 0)) {
            setInnerPending(true)

            // const email = emailValue

            // fetch(`${process.env.REACT_APP_API_URL}/mail/send_to_email`, {
            fetch(`${process.env.REACT_APP_API_URL}/mail/send_rich_hilllwood_email`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'Authorization': sessionStorage.getItem('agronetToken'),
                    'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
                },
                body: JSON.stringify(formValues)
            })
                .then(res => {
                    if(res.status === 200) {
                        setSuccessModal(true)
                        return console.log(res.json())
                    } else {
                        setErrorModal(true)
                    }
                })
                .catch(err => {
                    setErrorModal(true)
                    console.log('ERROR', err);
                })

            setInnerPending(false)
        }
    }

    return (
        <div className="ShareMailWrapper">
            <img src={bg} alt="bg image" className="backgroundImage"/>
            <div className="aboveBtnsContainer">
                <div className="topBtns">
                    <div className="aboveBtn">
                        <ArrowLeft />
                        {t.gettext('Wróć do listy inwestycji')}
                    </div>
                </div>
                {/*<div className="bottomBtns">*/}
                {/*    <div className="aboveBtn">*/}
                {/*        {t.gettext('wersja PL')}*/}
                {/*    </div>*/}
                {/*    <div className="aboveBtn">*/}
                {/*        {t.gettext('wersja ENG')}*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
            <div className="ShareMailContainer">
                <div className="headerBtns">
                    <div className="headerBtn">
                        <ShareIcon />
                        <span>{t.gettext('Udostępnij')}</span>
                    </div>
                    <div className="headerBtn">
                        <CopyIcon />
                        <span>{t.gettext('Kopiuj link do strony')}</span>
                    </div>
                </div>

                <div className="mainContainer">
                    <div className="leftSide">

                       <div className="titleSection">
                           <p className="inBuilt">
                               {t.gettext('W budowie')}
                           </p>
                           <h1>{t.gettext('Hillwood Częstochowa - Miasto')}</h1>
                           <div className="subtitleContainer">
                               {t.gettext('Koszewy Kościelne 23B, Kaszewy Kościelne')}
                               <div className="subtitleBg">
                                   {t.gettext('Górny Śląsk')}
                               </div>
                           </div>
                       </div>

                        <div className="infoSection">
                            <label className='checkboxContainer'>
                                <p className='checkboxText'>{t.gettext('O inwestycji')}</p>
                                <input type="checkbox"
                                    // checked
                                    // value={formValues.descriptionAttached}
                                       onChange={() => setFormValues({
                                           ...formValues,
                                           descriptionAttached: !formValues.descriptionAttached
                                       })}
                                       checked={formValues.descriptionAttached}
                                />
                                <span className="checkMark"/>
                            </label>
                                <div className="infoText">
                                    {t.gettext('Hillwood Częstochowa-Miasto to nowoczesny park magazynowy zlokalizowany w Częstochowie bezpośrednio przy drodze krajowej nr 91, łączącej północ z południem Polski. Ta miejska lokalizacja zapewnia doskonałą widoczność obiektu, szybki dostęp do trasy wyjazdowej a także dostęp do wykwalifikowanej kadry pracowniczej. Park składa się z dwóch hal o łącznej powierzchni około 64 000 m2.')}
                                </div>
                        </div>

                        <div className="keyFactsSection">
                            <div className="sectionTitle">
                                {t.gettext('Key facts')}
                            </div>
                            <div className="detailsGrid">
                                <div className="gridItem">
                                    <p className="itemTitle">
                                        {t.gettext('STATUS')}
                                    </p>
                                    <p className="itemText">
                                        {t.gettext('Planowany')}
                                    </p>
                                </div>
                                <div className="gridItem">
                                    <p className="itemTitle">
                                        {t.gettext('DOSTĘPNA POWIERZCHNIA')}
                                    </p>
                                    <p className="itemText">
                                        {t.gettext('xxx xxxm2')}
                                    </p>
                                </div>
                                <div className="gridItem">
                                    <p className="itemTitle">
                                        {t.gettext('WIELKOŚĆ PARKU')}
                                    </p>
                                    <p className="itemText">
                                        {t.gettext('xxx xxxm2')}
                                    </p>
                                </div>
                                <div className="gridItem">
                                    <p className="itemTitle">
                                        {t.gettext('MINIMALNY MODUŁ')}
                                    </p>
                                    <p className="itemText">
                                        {t.gettext('xxx xxxm2')}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="techSpecSection">
                            <div className="checkboxSpecWrap">
                                <label className='checkboxContainer'>
                                    <p className='checkboxText'>{t.gettext('Specyfikacja techniczna')}</p>
                                    <input type="checkbox"
                                        // checked
                                        // value={formValues.descriptionAttached}
                                           onChange={() => setFormValues({
                                               ...formValues,
                                               projectTechSpecAttached: !formValues.projectTechSpecAttached
                                           })}
                                           checked={formValues.projectTechSpecAttached}
                                    />
                                    <span className="checkMark"/>
                                </label>
                            </div>
                            {/*<div className="sectionTitle">*/}
                            {/*    {t.gettext('Specyfikacja techniczna')}*/}
                            {/*</div>*/}
                            <div className="detailsGrid">
                                <div className="gridItem">
                                    <p className="itemTitle">
                                        {t.gettext('WYSOKOŚĆ SKŁADOWANIA')}
                                    </p>
                                    <p className="itemText">
                                        {t.gettext('xx m')}
                                    </p>
                                </div>
                                <div className="gridItem">
                                    <p className="itemTitle">
                                        {t.gettext('SIATKA SŁUPÓW')}
                                    </p>
                                    <p className="itemText">
                                        {t.gettext('A: 12x24, B: 12x22')}
                                    </p>
                                </div>
                                <div className="gridItem">
                                    <p className="itemTitle">
                                        {t.gettext('NOŚNOŚĆ POSADZKI')}
                                    </p>
                                    <p className="itemText">
                                        {t.gettext('6T/m2')}
                                    </p>
                                </div>
                                <div className="gridItem">
                                    <p className="itemTitle">
                                        {t.gettext('ODPORNOŚĆ OGNIOWA')}
                                    </p>
                                    <p className="itemText">
                                        {t.gettext('do 4 000 mJ / m2')}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="marketingSection">
                            <div className="sectionTitle">
                                {t.gettext('Narzędzia marketingowe')}
                            </div>
                            <div className="marketingItems">
                                <div className="wideItem">
                                    <div className="wideItemleft">
                                        <label className='checkboxContainer'>
                                            <p className='checkboxText'>{'Broszura online'}</p>
                                            <input type="checkbox"
                                                // checked
                                                   onChange={() => setFormValues({
                                                       ...formValues,
                                                       bookletAttached: !formValues.bookletAttached
                                                   })}
                                                   checked={formValues.bookletAttached}
                                            />
                                            <span className="checkMark"/>
                                        </label>
                                        {/*<CircleSquare />*/}
                                        {/*{t.gettext('Broszura online')}*/}
                                    </div>
                                    {/*<ShareIcon />*/}
                                </div>
                                <div className="wideItem">
                                    <div className="wideItemleft">
                                        <CircleSquare />
                                        {t.gettext('Broszura PDF')}
                                    </div>
                                    <ShareIcon />
                                </div>
                                <div className="wideItem">
                                    <div className="wideItemleft">
                                        <label className='checkboxContainer'>
                                            <p className='checkboxText'>{'Video'}</p>
                                            <input type="checkbox"
                                                // checked
                                                   onChange={() => setFormValues({
                                                       ...formValues,
                                                       videoAttached: !formValues.videoAttached
                                                   })}
                                                   checked={formValues.videoAttached}
                                            />
                                            <span className="checkMark"/>
                                        </label>
                                        {/*<CircleSquare />*/}
                                        {/*{t.gettext('Film')}*/}
                                    </div>
                                    {/*<ShareIcon />*/}
                                </div>
                                <div className="wideItem">
                                    <div className="wideItemleft">
                                        <CircleSquare />
                                        {t.gettext('Panorama 360')}
                                    </div>
                                    <ShareIcon />
                                </div>
                                <div className="wideItem">
                                    <div className="wideItemleft">
                                        <CircleSquare />
                                        {t.gettext('Spacer wirtualny')}
                                    </div>
                                    <ShareIcon />
                                </div>
                                <div className="wideItem">
                                    <div className="wideItemleft">
                                        <CircleSquare />
                                        {t.gettext('Komunikacja')}
                                    </div>
                                    <ShareIcon />
                                </div>
                            </div>
                        </div>

                        <div className="checkboxSection">
                            <div className="shareInputContainer">
                                <span className="shareTxt">Send us your e-mail</span>
                                <input
                                    className='shareInput'
                                    type="text"
                                    value={formValues.email}
                                    onInput={(e) => setFormValues({...formValues, email: e.target.value})}
                                />
                            </div>
                            <div
                                onClick={sendEmail}
                                className="shareBtn">
                                Send
                            </div>
                            {successModal && (
                                <ErrorModal
                                    error={'Email sent'}
                                    closeMethod={() => setSuccessModal(!successModal)}
                                />
                            )}
                            {errorModal && (
                                <ErrorModal
                                    error={'Error: Something went wrong'}
                                    closeMethod={() => setErrorModal(!errorModal)}
                                />
                            )}
                        </div>
                    </div>

                    {/*//right side*/}


                    <div className="rightSide">
                        <div className="gallerySection">
                            <div className="checkboxSpecWrap">
                                <label className='checkboxContainer'>
                                    <p className='checkboxText'>{t.gettext('Galeria')}</p>
                                    <input type="checkbox"
                                        // checked
                                        // value={formValues.descriptionAttached}
                                           onChange={() => setFormValues({
                                               ...formValues,
                                               galleryAttached: !formValues.galleryAttached
                                           })}
                                           checked={formValues.galleryAttached}
                                    />
                                    <span className="checkMark"/>
                                </label>
                            </div>
                            {/*<div className="sectionBigTitle">*/}
                            {/*    {t.gettext('Galeria')}*/}
                            {/*    <ShareIcon />*/}
                            {/*</div>*/}
                            <div className="gridImageContainer">
                                <div className="firstRow">
                                    <img src={smallBg} alt="big grid img" className="gridBigImg"/>
                                </div>
                               <div className="secondRow">
                                   <img src={smallBg} alt="small grid img" className="smallImg"/>
                                   <img src={smallBg} alt="small grid img" className="smallImg"/>
                                   <img src={smallBg} alt="small grid img" className="smallImg"/>
                               </div>

                            </div>
                        </div>

                        <div className="mapSection">
                            <div className="checkboxSpecWrap">
                                <label className='checkboxContainer'>
                                    <p className='checkboxText'>{'Mapy'}</p>
                                    <input type="checkbox"
                                        // checked
                                           onChange={() => setFormValues({
                                               ...formValues,
                                               mapAttached: !formValues.mapAttached
                                           })}
                                           checked={formValues.mapAttached}
                                    />
                                    <span className="checkMark"/>
                                </label>
                            </div>
                            {/*<div className="sectionBigTitle">*/}
                            {/*    {t.gettext('Lokalizacja')}*/}
                            {/*    <ShareIcon />*/}
                            {/*</div>*/}
                            <div className="mapImage">
                                <img src={map} alt="map screen"/>
                            </div>
                        </div>

                        <div className="visualizationSection">
                            <div className="checkboxSpecWrap">
                                <label className='checkboxContainer'>
                                    <p className='checkboxText'>{'Site Plan'}</p>
                                    <input type="checkbox"
                                        // checked
                                           onChange={() => setFormValues({
                                               ...formValues,
                                               sitePlanAttached: !formValues.sitePlanAttached
                                           })}
                                           checked={formValues.sitePlanAttached}
                                    />
                                    <span className="checkMark"/>
                                </label>
                            </div>
                            {/*<div className="sectionBigTitle">*/}
                            {/*    {t.gettext('Wizualizacje')}*/}
                            {/*    <ShareIcon />*/}
                            {/*</div>*/}
                            <div className="gridImageContainer">
                                <div className="firstRow">
                                    <img src={gray} alt="big grid img" className="gridBigImg"/>
                                </div>
                                <div className="secondRow">
                                    <img src={gray} alt="small grid img" className="smallImg"/>
                                    <img src={gray} alt="small grid img" className="smallImg"/>
                                    <img src={gray} alt="small grid img" className="smallImg"/>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>




                {/*<div className="testDiv"></div>*/}
                {/*<div className="testDiv"></div>*/}
                {/*<div className="testDiv"></div>*/}
                {/*<div className="testDiv"></div>*/}
                {/*<div className="testDiv"></div>*/}

            </div>
        </div>
        // <div className="ShareMail">
        //     <div className="shareInputContainer">
        //
        //         <span className="shareTxt">Send us your e-mail</span>
        //         <input
        //             className='shareInput'
        //             type="text"
        //             value={formValues.email}
        //             onInput={(e) => setFormValues({...formValues, email: e.target.value})}
        //         />
        //         <div className="shareForm">
        //             <label className='checkboxContainer'>
        //                 <p className='checkboxText'>{'Project description'}</p>
        //                 <input type="checkbox"
        //                     // checked
        //                     // value={formValues.descriptionAttached}
        //                     onChange={() => setFormValues({...formValues, descriptionAttached: !formValues.descriptionAttached})}
        //                     checked={formValues.descriptionAttached}
        //                 />
        //                 <span className="checkMark"/>
        //             </label>
        //             <label className='checkboxContainer'>
        //                 <p className='checkboxText'>{'Technical details'}</p>
        //                 <input type="checkbox"
        //                     // checked
        //                        onChange={() => setFormValues({...formValues, projectTechSpecAttached: !formValues.projectTechSpecAttached})}
        //                        checked={formValues.projectTechSpecAttached}
        //                 />
        //                 <span className="checkMark"/>
        //             </label>
        //             <label className='checkboxContainer'>
        //                 <p className='checkboxText'>{'Gallery'}</p>
        //                 <input type="checkbox"
        //                     // checked
        //                        onChange={() => setFormValues({...formValues, galleryAttached: !formValues.galleryAttached})}
        //                        checked={formValues.galleryAttached}
        //                 />
        //                 <span className="checkMark"/>
        //             </label>
        //             <label className='checkboxContainer'>
        //                 <p className='checkboxText'>{'Maps'}</p>
        //                 <input type="checkbox"
        //                     // checked
        //                        onChange={() => setFormValues({...formValues, mapAttached: !formValues.mapAttached})}
        //                        checked={formValues.mapAttached}
        //                 />
        //                 <span className="checkMark"/>
        //             </label>
        //             <label className='checkboxContainer'>
        //                 <p className='checkboxText'>{'Site Plan'}</p>
        //                 <input type="checkbox"
        //                     // checked
        //                        onChange={() => setFormValues({...formValues, sitePlanAttached: !formValues.sitePlanAttached})}
        //                        checked={formValues.sitePlanAttached}
        //                 />
        //                 <span className="checkMark"/>
        //             </label>
        //             <label className='checkboxContainer'>
        //                 <p className='checkboxText'>{'Booklet'}</p>
        //                 <input type="checkbox"
        //                     // checked
        //                        onChange={() => setFormValues({...formValues, bookletAttached: !formValues.bookletAttached})}
        //                        checked={formValues.bookletAttached}
        //                 />
        //                 <span className="checkMark"/>
        //             </label>
        //             <label className='checkboxContainer'>
        //                 <p className='checkboxText'>{'Video'}</p>
        //                 <input type="checkbox"
        //                     // checked
        //                        onChange={() => setFormValues({...formValues, videoAttached: !formValues.videoAttached})}
        //                        checked={formValues.videoAttached}
        //                 />
        //                 <span className="checkMark"/>
        //             </label>
        //         </div>
        //         <div
        //             onClick={sendEmail}
        //             className="shareBtn">
        //             Send
        //         </div>
        //         {successModal && (
        //             <ErrorModal
        //                 error={'Email sent'}
        //                 closeMethod={() => setSuccessModal(!successModal)}
        //             />
        //         )}
        //         {errorModal && (
        //             <ErrorModal
        //                 error={'Error: Something went wrong'}
        //                 closeMethod={() => setErrorModal(!errorModal)}
        //             />
        //         )}
        //     </div>
        // </div>
    )
}

export default ShareMail
